module.exports = __webpack_public_path__ + "media/nicole9.6db3205f.mp3";